import React, {useState} from "react";
import {FormControl, Grid, MenuItem} from "@mui/material";
import moment from "moment";
import {useTranslation} from "react-i18next";
import I18nTextField from "../../../i18n-text-field";

const TimePeriodSettings = ({
  watch,
  setValue,
  errors,
  fieldStyle,
  formatYear,
  formatMonth,
  formatDay,
  formatQuarter,
  formatSemester,
  formatQuadrimester,
  formatDate,
  formatTime
}) => {
  const {t} = useTranslation();
  const [dateForm] = useState(moment().set({hour: 6, minute: 30, second: 15}));

  const formatLabel = format => `${dateForm.customFormat(format)} (${format})`;

  return (
    <Grid container spacing={2} sx={fieldStyle}>
      <Grid size={12}>{t("scenes.nodeSettings.fields.timePeriodFormat.label")}:</Grid>
      {formatYear && (
        <Grid size={6}>
          <FormControl fullWidth sx={fieldStyle} id="node-settings-form__time-period-format-year">
            <I18nTextField
              name="timePeriodFormatYear"
              select
              required
              label={t("scenes.nodeSettings.fields.timePeriodFormatYear.label")}
              onChange={value => setValue("timePeriodFormatYear", value)}
              value={watch("timePeriodFormatYear") || ""}
              error={!!errors.timePeriodFormatYear}
              helperText={errors.timePeriodFormatYear?.message}
              variant="outlined"
              SelectProps={{SelectDisplayProps: {"aria-haspopup": true}}}
            >
              {formatYear.map(format => (
                <MenuItem key={format} value={format}>
                  {formatLabel(format)}
                </MenuItem>
              ))}
            </I18nTextField>
          </FormControl>
        </Grid>
      )}
      {formatMonth && (
        <Grid size={6}>
          <FormControl fullWidth sx={fieldStyle} id="node-settings-form__time-period-format-month">
            <I18nTextField
              name="timePeriodFormatMonth"
              select
              required
              label={t("scenes.nodeSettings.fields.timePeriodFormatMonth.label")}
              onChange={value => setValue("timePeriodFormatMonth", value)}
              value={watch("timePeriodFormatMonth") || ""}
              error={!!errors.timePeriodFormatMonth}
              helperText={errors.timePeriodFormatMonth?.message}
              variant="outlined"
              SelectProps={{SelectDisplayProps: {"aria-haspopup": true}}}
            >
              {formatMonth.map(format => (
                <MenuItem key={format} value={format}>
                  {formatLabel(format)}
                </MenuItem>
              ))}
            </I18nTextField>
          </FormControl>
        </Grid>
      )}
      {formatDay && (
        <Grid size={6}>
          <FormControl fullWidth sx={fieldStyle} id="node-settings-form__time-period-format-day">
            <I18nTextField
              name="timePeriodFormatDay"
              select
              required
              label={t("scenes.nodeSettings.fields.timePeriodFormatDay.label")}
              onChange={value => setValue("timePeriodFormatDay", value)}
              value={watch("timePeriodFormatDay") || ""}
              error={!!errors.timePeriodFormatDay}
              helperText={errors.timePeriodFormatDay?.message}
              variant="outlined"
              SelectProps={{SelectDisplayProps: {"aria-haspopup": true}}}
            >
              {formatDay.map(format => (
                <MenuItem key={format} value={format}>
                  {formatLabel(format)}
                </MenuItem>
              ))}
            </I18nTextField>
          </FormControl>
        </Grid>
      )}
      {formatQuarter && (
        <Grid size={6}>
          <FormControl fullWidth sx={fieldStyle} id="node-settings-form__time-period-format-quarter">
            <I18nTextField
              name="timePeriodFormatQuarter"
              select
              required
              label={t("scenes.nodeSettings.fields.timePeriodFormatQuarter.label")}
              onChange={value => setValue("timePeriodFormatQuarter", value)}
              value={watch("timePeriodFormatQuarter") || ""}
              error={!!errors.timePeriodFormatQuarter}
              helperText={errors.timePeriodFormatQuarter?.message}
              variant="outlined"
              SelectProps={{SelectDisplayProps: {"aria-haspopup": true}}}
            >
              {formatQuarter.map(format => (
                <MenuItem key={format} value={format}>
                  {formatLabel(format)}
                </MenuItem>
              ))}
            </I18nTextField>
          </FormControl>
        </Grid>
      )}
      {formatSemester && (
        <Grid size={6}>
          <FormControl fullWidth sx={fieldStyle} id="node-settings-form__time-period-format-semester">
            <I18nTextField
              name="timePeriodFormatSemester"
              select
              required
              label={t("scenes.nodeSettings.fields.timePeriodFormatSemester.label")}
              onChange={value => setValue("timePeriodFormatSemester", value)}
              value={watch("timePeriodFormatSemester") || ""}
              error={!!errors.timePeriodFormatSemester}
              helperText={errors.timePeriodFormatSemester?.message}
              variant="outlined"
              SelectProps={{SelectDisplayProps: {"aria-haspopup": true}}}
            >
              {formatSemester.map(format => (
                <MenuItem key={format} value={format}>
                  {formatLabel(format)}
                </MenuItem>
              ))}
            </I18nTextField>
          </FormControl>
        </Grid>
      )}
      {formatQuadrimester && (
        <Grid size={6}>
          <FormControl fullWidth sx={fieldStyle} id="node-settings-form__time-period-format-quadrimester">
            <I18nTextField
              name="timePeriodFormatQuadrimester"
              select
              required
              label={t("scenes.nodeSettings.fields.timePeriodFormatQuadrimester.label")}
              onChange={value => setValue("timePeriodFormatQuadrimester", value)}
              value={watch("timePeriodFormatQuadrimester") || ""}
              error={!!errors.timePeriodFormatQuadrimester}
              helperText={errors.timePeriodFormatQuadrimester?.message}
              variant="outlined"
              SelectProps={{SelectDisplayProps: {"aria-haspopup": true}}}
            >
              {formatQuadrimester.map(format => (
                <MenuItem key={format} value={format}>
                  {formatLabel(format)}
                </MenuItem>
              ))}
            </I18nTextField>
          </FormControl>
        </Grid>
      )}
      {formatDate && (
        <Grid size={6}>
          <FormControl fullWidth sx={fieldStyle} id="node-settings-form__time-period-format-date">
            <I18nTextField
              name="timePeriodFormatDate"
              select
              required
              label={t("scenes.nodeSettings.fields.timePeriodFormatDate.label")}
              onChange={value => setValue("timePeriodFormatDate", value)}
              value={watch("timePeriodFormatDate") || ""}
              error={!!errors.timePeriodFormatDate}
              helperText={errors.timePeriodFormatDate?.message}
              variant="outlined"
              SelectProps={{SelectDisplayProps: {"aria-haspopup": true}}}
            >
              {formatDate.map(format => (
                <MenuItem key={format} value={format}>
                  {formatLabel(format)}
                </MenuItem>
              ))}
            </I18nTextField>
          </FormControl>
        </Grid>
      )}
      {formatTime && (
        <Grid size={6}>
          <FormControl fullWidth sx={fieldStyle} id="node-settings-form__time-period-format-time">
            <I18nTextField
              name="timePeriodFormatTime"
              select
              required
              label={t("scenes.nodeSettings.fields.timePeriodFormatTime.label")}
              onChange={value => setValue("timePeriodFormatTime", value)}
              value={watch("timePeriodFormatTime") || ""}
              error={!!errors.timePeriodFormatTime}
              helperText={errors.timePeriodFormatTime?.message}
              variant="outlined"
              SelectProps={{SelectDisplayProps: {"aria-haspopup": true}}}
            >
              {formatTime.map(format => (
                <MenuItem key={format} value={format}>
                  {formatLabel(format)}
                </MenuItem>
              ))}
            </I18nTextField>
          </FormControl>
        </Grid>
      )}
    </Grid>
  );
};

export default TimePeriodSettings;
